export const PROMOTION_PERMISSIONS = {
    schoolView: "promotion:school:view",
    schoolEdit: "promotion:school:edit",
    buildingView: "promotion:building:view",
    buildingEdit: "promotion:building:edit",
    leaderView: "promotion:leader:view",
    leaderEdit: "promotion:leader:edit",
    statisticsView: "promotion:statistics:view",
    invitationView: "promotion:invitation:view",
    invitationOperate: "promotion:invitation:operate",
    posterTemplateView: "promotion:poster-template:view",
    posterTemplateEdit: "promotion:poster-template:edit",
    posterView: "promotion:poster:view",
};

export const PROMOTION_MENU = [
    {
        key: "basics",
        label: "学校与宿舍楼",
        permissions: [
            PROMOTION_PERMISSIONS.schoolView,
            PROMOTION_PERMISSIONS.schoolEdit,
            PROMOTION_PERMISSIONS.buildingView,
            PROMOTION_PERMISSIONS.buildingEdit,
        ],
    },
    {
        key: "leaders",
        label: "楼长任职与统计",
        permissions: [
            PROMOTION_PERMISSIONS.leaderView,
            PROMOTION_PERMISSIONS.leaderEdit,
            PROMOTION_PERMISSIONS.statisticsView,
            PROMOTION_PERMISSIONS.posterView,
        ],
    },
    {
        key: "invitations",
        label: "邀请关系",
        permissions: [
            PROMOTION_PERMISSIONS.invitationView,
            PROMOTION_PERMISSIONS.invitationOperate,
        ],
    },
    {
        key: "posters",
        label: "海报模板与官方海报",
        permissions: [
            PROMOTION_PERMISSIONS.posterTemplateView,
            PROMOTION_PERMISSIONS.posterTemplateEdit,
            PROMOTION_PERMISSIONS.posterView,
        ],
    },
];

export default PROMOTION_MENU;
